import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFile, faTimes, faPlus, faEdit } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';
import { ItemListComponent, ListItem, ListConfig } from '../item-list/item-list.component';
import { HeaderActionsComponent, HeaderActionsConfig } from '../header-actions/header-actions.component';
import { ModalInteractionArchivesAddComponent } from '../modal-interaction-archives-add/modal-interaction-archives-add.component';
import { InteractionsService } from '../../services/interactions.service';
import { AlertService } from '../alert-service/alert-service';
import { normalizeForSearch } from '../../utils/text-search.util';

@Component({
  selector: 'app-modal-interaction-archives-details',
  standalone: true,
  imports: [
    FontAwesomeModule,
    TranslateModule,
    ItemListComponent,
    HeaderActionsComponent,
    ModalInteractionArchivesAddComponent
],
  templateUrl: './modal-interaction-archives-details.component.html',
  styleUrls: ['./modal-interaction-archives-details.component.scss']
})
export class ModalInteractionArchivesDetailsComponent implements OnInit, OnChanges {
  @Input() show = false;
  @Input() interactionId: string = '';
  @Output() close = new EventEmitter<void>();

  faFile = faFile;
  faTimes = faTimes;
  faPlus = faPlus;
  archives: any[] = [];
  filteredArchives: ListItem[] = [];
  searchTerm: string = '';
  showAddModal = false;

  listConfig: ListConfig = {
    itemIcon: faFile,
    itemIconClass: 'file-icon',
    showMetadata: false,
    showType: false,
    emptyMessage: 'MESSAGE.NO.ARCHIVES',
    emptyMessageFiltered: 'MESSAGE.NO.ARCHIVES_FILTERED',
    actions: []
  };

  headerConfig: HeaderActionsConfig = {
    addButton: {
      type: 'add',
      text: 'BUTTON.ADD',
      icon: faPlus,
      visible: true,
      disabled: false
    },
    showAddButton: false,
    searchConfig: {
      showTextSearch: true,
      showTagFilter: false,
      textPlaceholder: 'SEARCH.PLACEHOLDER.ARCHIVES',
      tagPlaceholder: ''
    }
  };

  constructor(private interactionsService: InteractionsService, private alertService: AlertService) {}

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['show'] && this.show && this.interactionId) {
      this.loadArchives();
    }
  }

  loadArchives() {
    this.interactionsService.listArchives(this.interactionId).subscribe({
      next: (data) => {
        this.archives = data || [];
        this.applyFilter();
      },
      error: (err) => {
        this.archives = [];
        this.filteredArchives = [];
        this.alertService.showError(err);
      }
    });
  }

  onSearchChange(term: string) {
    this.searchTerm = term;
    this.applyFilter();
  }

  applyFilter() {
    const term = normalizeForSearch(this.searchTerm);
    let filtered = this.archives;
    if (term) {
      filtered = this.archives.filter(a =>
        normalizeForSearch(a.name).includes(term)
      );
    }
    this.filteredArchives = filtered.map(a => ({
      id: a.id,
      name: a.name
    }));
  }

  onClose() {
    this.close.emit();
  }

  onAddArchive() {
    this.showAddModal = true;
  }

  onCloseAddModal() {
    this.showAddModal = false;
    this.loadArchives();
  }
}